import { withStyles } from "@material-ui/core";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import React from "react";
import Scroll from "../../../../components/InfiniteScroll/Scroll";
import Table from "../../../../components/Table/Table";
import { tussTableHeaderColumns } from "../constants/tableHeaderColumns";

const ContentProcedimentosSelecionados = observer(({
  classes,
  TGOStore,
}) => {
  const { objView } = TGOStore;
  const handleClickRemove = (selectedIndex) => {
    objView.guiaServicoTgoTussViews.splice(selectedIndex, 1);
  };

  return (
    <Scroll classes={{ root: classes.tussTable }}>
      <Table
        columns={tussTableHeaderColumns({
          handleRemoveTuss: handleClickRemove,
        })}
        classes={{
          tableCell: classes.tussTableCell,
        }}
        dados={objView.guiaServicoTgoTussViews}
      />
    </Scroll>
  );
});

const styles = {
  tussTable: {
    maxHeight: '165px',
    minWidth: '500px',
    flex: 1,
    marginTop: '8px',
    border: 'solid 1px rgba(0, 0, 0, 0.2)',
    borderRadius: '8px',
    '&>div>div>table>thead>tr': {
      height: '40px',
      '&>th': {
        padding: '0 8px',
        textAlign: 'center'
      }
    },
    '&>div>div>table>tbody>tr': {
      height: '40px',
      '&>td': {
        padding: '0 8px',
        textAlign: 'center',
      }
    }
  },
  tussTableCell: {
    padding: 0,
    margin: 0,
  },
}
 
const ContentProcedimentosSelecionadosWithStyles = withStyles(styles)(
  ContentProcedimentosSelecionados
);
export default inject("TGOStore")(ContentProcedimentosSelecionadosWithStyles);